import { render, staticRenderFns } from "./Immobilier.vue?vue&type=template&id=55967c12&scoped=true&"
import script from "./Immobilier.vue?vue&type=script&lang=js&"
export * from "./Immobilier.vue?vue&type=script&lang=js&"
import style0 from "./Immobilier.vue?vue&type=style&index=0&id=55967c12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55967c12",
  null
  
)

export default component.exports